import type { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';

import type { LcpnTheme } from '../../styles/theme';
import { nccpLegendConfig } from '../../map-data/heatmap-legend-config';
import { Typography } from '../Typography';

import { KeyColor } from './KeyColor';

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  legend: {
    position: 'absolute',
    bottom: 38,
    right: 8,
    background: 'rgba(255, 255, 255, 0.85)',
    borderRadius: 12.5,
    minWidth: 250,
    padding: theme.spacing(3),
  },

  values: {
    display: 'flex',
    flexDirection: 'column',
  },

  item: {
    display: 'flex',
    gap: theme.spacing(2),
    fontSize: theme.fontSizes.p2,
    alignItems: 'center',
  },

  note: {
    textAlign: 'center',
    paddingTop: theme.spacing(2),
    width: '100%',
    maxWidth: '12em',
    margin: '0 auto',
  },
}));

export const NccpLegend: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.legend}>
      <div className={classes.values}>
        {nccpLegendConfig.map((item, index) => (
          <div key={index} className={classes.item}>
            <KeyColor color={item.color} />
            <span>{t(`nccpLegend.${item.translationKey}`)}</span>
          </div>
        ))}
      </div>
      <div className={classes.note}>
        <Typography variant="p3">{t('nccpLegend.note')}</Typography>
      </div>
    </div>
  );
};
